import { render } from "./당뇨합병증클리닉.vue?vue&type=template&id=02db7987"
import script from "./당뇨합병증클리닉.vue?vue&type=script&lang=js"
export * from "./당뇨합병증클리닉.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__